import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionLabelProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * SectionLabel — small uppercase mono-tracked eyebrow above a group of content
 * (Calm Authority primitive). Presentational: the caller supplies already
 * translated text via `children`, so this stays namespace-agnostic. Styling is
 * token-driven (--ink-3, --tracking-label) so it re-themes with the token scale.
 */
export function SectionLabel(
  { children, className, ...props }: SectionLabelProps,
) {
  return (
    <div
      data-slot="section-label"
      className={cn(
        "font-bold text-xs uppercase tracking-[var(--tracking-label)] text-[var(--ink-3)]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
